import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Resolve,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { Match } from "@shared/models/match";
import { MatchService } from "@core/services/match.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TypeService } from "@core/services/type.service";
import { PageType } from "../../../page-type";
import { HomeRoutes } from "@app/routes/home.routes";
import { TeamRoutes } from "@app/routes/team.routes";
import { EventsHttpService } from "@api/http/events/events-http.service";
import { Event } from "@api/models/event/event";

@Injectable({ providedIn: "root" })
export class MatchResolver implements Resolve<Event> {
  constructor(
    private eventsHttp: EventsHttpService,
    private matchService: MatchService,
    private snackbar: MatSnackBar,
    private router: Router
  ) {}

  public async resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<Event> {
    let eventId = route.queryParams["eventid"];
    try {
      if (!eventId) {
        eventId = route.paramMap.get("id");
      }
      // Filter old urls like "5f8ff850d94bd3349a7a0d82-tsg-hoffenheim-vs-kaa-gent-10-12-2020"
      const splitUrl = eventId.split("-");
      const isOldSlugifiedUrl = splitUrl.length > 1;
      if (isOldSlugifiedUrl) {
        eventId = splitUrl[0];
      }
      const game = await this.eventsHttp.getEvent(eventId);
      if (!game) {
        this.handleError(eventId);
        return;
      }
      return game;
    } catch (e) {
      this.handleError(eventId);
    }
  }

  private handleError(gameId: string): void {
    console.warn("[Match Resolver] Could not fetch match", gameId);
    this.snackbar.open("Spiel konnte nicht geladen werden!", null, {
      duration: 2000,
    });
    const route =
      TypeService.pageType === PageType.Home
        ? HomeRoutes.games.relative.today
        : TeamRoutes.games.relative.upcoming;
    this.router.navigate([route]);
  }
}
